import { PrimaryButton } from '@/components/ui/Button';
import Section from '@/components/ui/Section';
import styled from 'styled-components';
import { MarkdownRichText } from '../shared';
import { Container } from '@/components/ui/flexbox';

export const Content = styled.div`
  width: 100%;
  height: ${({ $isFullHeight }) => ($isFullHeight ? '100vh' : 'auto')};
  justify-content: center;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 64px;
  align-items: center;

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(50%);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  animation: fadeInUp 600ms ease-in-out forwards;

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    gap: 32px;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 32px;
  padding: 32px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 16px;
  z-index: 1;
  width: 588px;
  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    width: 100%;
    padding: 24px;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: end;

  .companiesDropdown,
  .countryDropdown {
    background: white;
    border-radius: 16px;

    & > div > div:first-of-type {
      &:hover,
      &:focus-within {
        border-color: ${(props) => props.theme.colors.grey.dark};
      }
      border-color: ${(props) => props.$error && '#DE6869'};
    }

    & > * {
      font-size: 14px;
      line-height: 22px;
    }
  }

  ${PrimaryButton} {
    width: fit-content;
    font-family: ${(props) => props.theme.typography.family.body};
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
`;

export const LogoWrapper = styled.figure`
  margin-bottom: 32px;

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    margin-bottom: 16px;

    img {
      width: 97px;
      height: 24px;
    }
  }
`;
export const CustomSection = styled(Section)`
  position: relative;
  min-height: 100svh;
  background-color: ${(props) => props.theme.colors.neutral.default};
  overflow-y: hidden;
`;

export const CustomContainer = styled(Container)`
  padding-top: 24px;
  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    padding-top: 58px;
  }
`;

export const Field = styled.div`
  position: relative;
  width: 100%;
  > [class*='-Input'] {
    margin-top: 30px;
  }
`;
export const BackgroundShape = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  min-height: 50svh;
  left: 0;
  background: url('/assets/backgrounds/eligibility-check.svg') no-repeat bottom center;
`;

export const Title = styled(MarkdownRichText)`
  white-space: pre-line;
  text-align: center;
`;

export const CloseButtonPopUp = styled.button`
  position: absolute;
  top: 32px;
  right: 32px;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
`;
